import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {},
  containerDesktop: {
    display: ['none', 'flex'],
  },
  containerMobile: {
    display: ['flex', 'none'],
    justifyContent: 'center',
  },
  desktopButton: {
    minWidth: '180px',
    marginRight: '42px',
    textAlign: 'center',
    '&:last-child': {
      marginRight: '0px',
    },
    '&.selected': {
      backgroundColor: 'violet.100',
      color: 'white',
    },
  },
  tagContent: {
    padding: '8px 16px',
  },
};
